/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Brief_Result_ValueInputs */

const en_how_we_work_brief_result_value = /** @type {(inputs: How_We_Work_Brief_Result_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Less searching; a sourced draft ready to check`)
};

const lv_how_we_work_brief_result_value = /** @type {(inputs: How_We_Work_Brief_Result_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mazāk meklēšanas; sagatavota atbilde ar avotiem, ko pārbaudīt`)
};

/**
* | output |
* | --- |
* | "Less searching; a sourced draft ready to check" |
*
* @param {How_We_Work_Brief_Result_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_brief_result_value = /** @type {((inputs?: How_We_Work_Brief_Result_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Brief_Result_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_brief_result_value(inputs)
	return en_how_we_work_brief_result_value(inputs)
});